import React, { useEffect, useState, useRef } from 'react';
import {
  Typography,
  Button,
  Descriptions,
  Collapse,
  Input,
  DatePicker,
  Select,
  Tooltip,
  Popover,
  Space,
  Tag,
  Dropdown,
} from 'antd';
import {
  CloseOutlined,
  DownOutlined,
  ExportOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import dayjs from 'dayjs';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import UserAvatar from '../../../../components/userAvatar/index';
import {
  setsprintdata,
  setassigneelist,
  setbacklogdata,
  setEpiclist,
  setlabellist,
} from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import DetailsPage from './DetailsPage';
import { useSearchParams } from 'react-router-dom';
import { SquareCheck } from 'lucide-react';
import SubtaskObject from '@atlaskit/object/subtask';
import SubtaskmodalActivity from '../Board/SubtaskmodalActivity';
import { setStoryPoints } from 'store/actions';
import { FiExternalLink, FiX } from 'react-icons/fi';
import { FaLock, FaEye, FaShareAlt } from 'react-icons/fa';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import {
  Box,
  Flex,
  HStack,
  Icon,
  IconButton,
  Tab,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import {
  AddIcon,
  ChatIcon,
  RepeatIcon,
  BiReply,
  ChevronDownIcon,
} from '@chakra-ui/icons';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import TaskObject from '@atlaskit/object/task';
import LogWork from '../Board/LogWork';
import ListLinkedWorkItems from '../Board/ListLinkedWorkItems';
import LinkWorkItemInput from '../Board/LinkWorkItemInput';
import WebLink from '../Board/WebLink';
import WebLinkList from '../Board/ListWebLinks';

import ShareWorkItemModal from '../share/ShareWorkItemModal';

const { Title, Text } = Typography;
const { Panel } = Collapse;
const { Option } = Select;

const SubtaskDetailModal = ({
  projectId,
  onClose,
  selectedTask,
  fetchSubtaskData,
  handleAddNew,
  standalone,
  taskdata,
  selectedSubtask,
  subtaskDetails,
  setSubtaskDetails,
  getSubTaskDetails,
}) => {
 
  const [isExpanded, setIsExpanded] = useState(false);

  const [isShareOpen, setIsShareOpen] = useState(false); // share modal state

  const [subtitledit, setSubTitleEdit] = useState('');

  const [newStatus, setNewStatus] = useState('');
  const [statusOptions, setStatusOptions] = useState([]);
  const [dueDate, setDueDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [epic, setEpic] = useState(null);
  const [description, setDescription] = useState('');
  const [isEditingDesc, setIsEditingDesc] = useState(false);
  const [editedTitle, setEditedTitle] = useState(subtaskDetails?.subtask_title);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [openLinkWorkItem, setOpenLinkWorkItem] = useState(false);
  const [refreshLinkedItems, setRefreshLinkedItems] = useState(false);
  const [showWebLink, setShowWebLink] = useState(false);
  const [refreshLinks, setRefreshLinks] = useState(false);
  const [workItems, setWorkItems] = useState(null);
  const [assignee, setAssignee] = useState(
    subtaskDetails?.assignee_id || taskdata?.assignee_id || null,
  );
  const [labels, setLabels] = useState([]);
  const [story_points, setStoryPoints] = useState(null);
  const [loading, setLoading] = useState(false);

  const assigneeOptions = useSelector(
    (state) => state.Authentication?.assigneelist,
  );

  const epicOptions = useSelector((state) => state.Authentication?.Epiclist);

  const labelOptions = useSelector((state) => state.Authentication?.labellist);

  const containerRef = useRef(null);
  const dispatch = useDispatch();

  const handleMenuClick = (e) => {
    const selected = e.key;
    setNewStatus(selected);
    autoSaveSubtask('status', selected);
  };

  useEffect(() => {
    if (!containerRef.current) return;

    const computeExpanded = (width) => {
      setIsExpanded(width > 700);
    };

    computeExpanded(
      containerRef.current.offsetWidth || containerRef.current.clientWidth,
    );

    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = entry.contentRect?.width || entry.target.offsetWidth;
        computeExpanded(width);
      }
    });

    ro.observe(containerRef.current);

    return () => {
      ro.disconnect();
    };
  }, [containerRef]);

  const triggerRefresh = () => {
    setRefreshLinkedItems((prev) => !prev);
  };

  const handleSaveLink = (data) => {
  
    setRefreshLinks((prev) => !prev);
    // you can store it, send API, etc
    setShowWebLink(false);
  };

  useEffect(() => {
    if (selectedTask) {
      fetchSubtaskData();
    }
  }, [selectedTask]);

  const handleLogSaved = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const fetchMetadata = async (projectId) => {
    try {
      const [assigneeRes, epicRes, statusRes, labelRes] = await Promise.all([
        httpInjectorService.getProjectAssigneeList(projectId),
        httpInjectorService.getEpicList(projectId),
        httpInjectorService.ListBoardStatus(projectId),
        httpInjectorService.getLabelList(projectId),
      ]);

      if (assigneeRes?.status === 'success')
        // setAssigneeOptions(assigneeRes.data || []);
        dispatch(setassigneelist(assigneeRes.data));
      if (epicRes?.status === 'success')
        //  setEpicOptions(epicRes.data || []);
        dispatch(setEpiclist(epicRes.data || []));
      if (statusRes?.status === 'success')
        setStatusOptions(statusRes.data || []);
      if (labelRes?.status === 'success')
        // setLabelOptions(labelRes.data || []);
        dispatch(setlabellist(labelRes.data || []));
    } catch (error) {
      console.error('Error fetching metadata:', error);
    }
  };

  const autoSaveSubtask = async (field, value) => {
    if (!subtaskDetails?.subtask_id) return;

    const updatedSubtask = {
      ...subtaskDetails,
      [field]: value,
    };

    const payload = {
      project_id: projectId,
      task_id: selectedTask?.id,
      subtask_id: updatedSubtask.subtask_id,

      title: updatedSubtask.subtask_title || '',
      description: updatedSubtask.description || '',
      subtask_status: updatedSubtask.status || '',
      assignee_id: updatedSubtask.assignee_id || null,
      epic_id: updatedSubtask.epic_id || null,
      story_points: updatedSubtask.story_points || null,

      start_date: updatedSubtask.start_date
        ? dayjs(updatedSubtask.start_date).format('YYYY-MM-DD')
        : null,

      due_date: updatedSubtask.due_date
        ? dayjs(updatedSubtask.due_date).format('YYYY-MM-DD')
        : null,
      work_item_url: `${window.location.origin}/admin/taskBoard/${projectId}/subtaskDetails/${updatedSubtask.subtask_id}`,
    };

    try {
      setLoading(true);
      const res = await httpInjectorService.updatesubtaskdata(payload);

      if (res?.status === 'success') {
        setSubtaskDetails(updatedSubtask);
        fetchSubtaskData();
      }
    } catch (error) {
      console.error('AutoSave Subtask Failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const subtaskLabelUpdate = async (updatedLabels) => {
    try {
      if (!updatedLabels) return;

      const newLabels = updatedLabels.filter((label) => label.__isNew__);
      const newLabelNames = newLabels.map((label) => label.label);

      const existingLabels = updatedLabels.filter((label) => !label.__isNew__);
      const existingLabelIds = existingLabels.map(
        (label) => label.label_id || label.value,
      );

      const requestBody = {
        project_id: projectId,
        subtask_id: subtaskDetails?.subtask_id,
      };

      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }

      if (existingLabelIds.length > 0) {
        requestBody.labels_id = existingLabelIds;
      }

      const response =
        await httpInjectorService.updateSubtaskLabels(requestBody);

      if (response.status === 'success') {
        if (response.data?.updatedLabels) {
          setLabels(response.data.updatedLabels);
        }
      } else {
        console.warn('Failed to update labels:', response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    if (selectedSubtask) {
      fetchMetadata(projectId);
    }
    //console.log(selectedTask, 'selected task');
  }, [selectedSubtask]);

  useEffect(() => {
    getLinkedWorkItems();
  }, [subtaskDetails]);
 

  const getLinkedWorkItems = async () => {
    let reqbody = {
      item_type: 'subtask',
      item_id: subtaskDetails?.subtask_id,
    };
  
    try {
      let response = await httpInjectorService.getLinkedWorkItems(reqbody);
      if (response.status === 'success') {
        setWorkItems(response.data);
      } else {
        setWorkItems({});
      }
    } catch (e) {
      throw e;
    }
  };

  const handleOpenLinkWorkItem = () => {
    setOpenLinkWorkItem(true);
  };

  useEffect(() => {
    if (selectedSubtask && subtaskDetails) {
      setDueDate(subtaskDetails?.due_date || null);
      setStartDate(subtaskDetails?.start_date || null);
      setAssignee(subtaskDetails.assignee_id || null);
    } else if (taskdata) {
      setDueDate(taskdata?.due_date || null);
      setStartDate(taskdata?.start_date || null);
      setAssignee(taskdata.assignee_id || null);
    }
  }, [taskdata, subtaskDetails]);

  const getStatusColors = (status = '') => {
    const s = String(status || '')
      .toUpperCase()
      .trim();

    switch (s) {
      case 'DONE':
        return { bg: '#45d44fff', color: 'black' };
      case 'TO DO':
      case 'TODO':
        return { bg: '#E6E6E6', color: 'black' };
      default:
        return { bg: '#55b0e8ff', color: 'black' };
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      {statusOptions.map((s) => {
        const colors = getStatusColors(s.status_name);

        return (
          <Menu.Item key={s.status_name}>
            <span
              style={{
                backgroundColor: colors.bg,
                color: colors.color,
                fontWeight: 600,
                borderRadius: 30,
                padding: '3px 10px',
                fontSize: 12,
                display: 'inline-block',
                textTransform: 'uppercase',
              }}
            >
              {s.status_name}
            </span>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const currentStatus = newStatus || subtaskDetails?.status;
  const colors = getStatusColors(currentStatus);

  const ISSUE_TYPE_ICON_MAP = {
    1: TaskObject, // TASK
    2: StoryObject, // STORY
    3: BugObject, // BUG
  };

  const IssueIcon =
    ISSUE_TYPE_ICON_MAP[
      subtaskDetails?.issue_type_id ||
        selectedSubtask?.issue_type_id ||
        selectedSubtask?.task?.issue_type_id
    ];

  return (
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        flexDirection: isExpanded ? 'row' : 'column',
        height: '100%',
        background: '#fff',
        transition: 'all 0.3s ease',
        borderLeft: standalone ? 'none' : '1px solid #ddd',
      }}
    >
      <div
        style={{
          flex: isExpanded ? 2 : 1,
          overflowY: 'auto',
          paddingRight: 12,
        }}
      >
        {/* Header */}

        <Flex
          align="center"
          justify="space-between"
          px={4}
          py={2}
          borderBottom="1px solid #e2e8f0"
          bg="white"
          //flex="0 0 50px"

          height="48px"
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 100,
          }}
        >
          {/* Left: NubaxPulse WorkItem */}
          <Text fontWeight="600" color="black" fontSize="15px">
            NubaxPulse WorkItem
          </Text>

          {/* Right: Open in new tab + close */}
          <Flex align="center" gap={4}>
            <Tooltip title="Open in new tab">
              <a
                href={`/admin/taskBoard/${projectId}/subtaskDetails/${
                  subtaskDetails?.subtask_id || subtaskDetails?.id
                }`}
                rel="noopener noreferrer"
                target="_blank"
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                }}
              >
                <Icon as={FiExternalLink} boxSize={5} color="gray.700" />
              </a>
            </Tooltip>

            <Icon
              as={FiX}
              boxSize={5}
              color="gray.700"
              cursor="pointer"
              _hover={{ color: 'red.500' }}
              onClick={onClose}
            />
          </Flex>
        </Flex>
        <Flex
          justify="space-between"
          align="center"
          px={6}
          py={2}
          flex="0 0 50px"
          borderBottom="1px solid #e2e8f0"
          bg="white"
        >
          <Flex align="center" gap={3}>
            <Flex align="center" gap={1}>
              <IssueIcon width={35} />
              <Text fontSize="md" color="gray.700">
                {subtaskDetails?.issue_key}
              </Text>
            </Flex>

            <Text fontSize="md" color="gray.600">
              /
            </Text>

            <Flex align="center" gap={1}>
              <SubtaskObject
                size={25}
                stroke="#0052CC"
                fill="white"
                strokeWidth={2}
                style={{ flexShrink: 0 }}
              />
              <Text fontSize="md" color="gray.700">
                {selectedSubtask?.subtask_key || selectedSubtask?.key}
              </Text>
            </Flex>
          </Flex>

          <HStack spacing={2}>
            <IconButton icon={<FaLock />} size="sm" variant="ghost" />
            <LogWork
              work_Id={subtaskDetails?.subtask_id}
              work_Type="SUBTASK"
              taskDetails={subtaskDetails}
              onSaved={handleLogSaved}
            />
            <IconButton icon={<FaEye />} size="sm" variant="ghost" />
            <IconButton
              icon={<FaShareAlt />}
              size="sm"
              variant="ghost"
              onClick={() => setIsShareOpen(true)}
            />
            <IconButton
              icon={<AiOutlineThunderbolt />}
              size="sm"
              variant="ghost"
            />
          </HStack>
        </Flex>

        <div style={{ padding: '12px 16px' }}>
          {isEditingTitle ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                marginTop: 4,
              }}
            >
              <Input
                value={editedTitle || subtaskDetails.subtask_title}
                onChange={(e) => setEditedTitle(e.target.value)}
                autoFocus
                onPressEnter={() => {
                  setIsEditingTitle(false);
                  autoSaveSubtask('title', editedTitle);
                }}
                style={{ fontSize: 20, fontWeight: 700 }}
              />
              <Space>
                <CheckOutlined
                  style={{ fontSize: 20, color: 'green', cursor: 'pointer' }}
                  onClick={() => {
                    autoSaveSubtask('title', editedTitle);
                    setIsEditingTitle(false);
                  }}
                />

                <CloseOutlined
                  style={{ fontSize: 20, color: 'red', cursor: 'pointer' }}
                  onClick={() => {
                    setEditedTitle(subtaskDetails?.subtask_title || '');
                    setIsEditingTitle(false);
                  }}
                />
              </Space>
            </div>
          ) : (
            <Title
              level={4}
              style={{ margin: 0, cursor: 'pointer' }}
              onClick={() => setIsEditingTitle(true)}
            >
              {subtaskDetails?.subtask_title || 'Untitled Task'}
            </Title>
          )}

          {/* Status & Add dropdown */}
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10, // spacing between them
          }}
        >
          <Dropdown overlay={menu} trigger={['click']}>
            <Button
              type="default"
              style={{
                borderRadius: 20,
                backgroundColor: colors.bg,
                color: colors.color,
                fontWeight: 600,
                border: '1px solid rgba(56, 112, 190, 1)',
                textTransform: 'uppercase',
                fontSize: 12,
                padding: '2px 14px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {currentStatus}
              <DownOutlined style={{ fontSize: 10, marginLeft: 6 }} />
            </Button>
          </Dropdown>
          {/* Menu Button */}
          <Menu>
            <MenuButton
              as={IconButton}
              icon={<AddIcon />}
              size="sm"
              aria-label="Add actions"
              bg="#f3f4f6"
              border="1px solid #d1d5db"
              borderRadius="md"
              _hover={{ bg: '#e5e7eb' }}
              _active={{ bg: '#e5e7eb' }}
              color="gray.700"
            />

            <MenuList zIndex={2}>
              <MenuItem onClick={handleOpenLinkWorkItem}>
                Link work Items
              </MenuItem>

              <MenuItem onClick={() => console.log('Assign task clicked')}>
                Add connected work
              </MenuItem>

              <MenuItem onClick={() => console.log('Add comment clicked')}>
                Add web link
              </MenuItem>

              <MenuItem onClick={() => console.log('Assign task clicked')}>
                Page
              </MenuItem>

              <MenuItem onClick={() => console.log('Add attachment clicked')}>
                Whiteboard
              </MenuItem>
            </MenuList>
          </Menu>

          {/* Status Dropdown */}
        </div>

        <ShareWorkItemModal
          isOpen={isShareOpen}
          onClose={() => setIsShareOpen(false)}
          subtask_id={subtaskDetails?.subtask_id}
          issue_id={subtaskDetails?.issue_id}
          issue_type_id={subtaskDetails?.issue_type_id}
          // epic_id={taskdata?.epic_id}
          project_id={projectId || taskdata.project_id}
          // taskKey={taskDetails?.task_key || taskDetails?.task?.task_key}
        />

        {/* Content */}
        <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
          <Collapse
            accordion={false}
            bordered={false}
            defaultActiveKey={['desc', 'subtask', 'details', 'activity']}
            expandIconPosition="end"
            style={{ background: 'transparent' }}
          >
            {/* Description */}
            <Panel
              header={
                <span style={{ fontSize: 18, fontWeight: 600 }}>
                  Description
                </span>
              }
              key="desc"
              style={{ background: 'transparent' }}
            >
              {isEditingDesc ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12,
                    paddingBottom: 16,
                  }}
                >
                  <div
                    style={{
                      border: '1px solid #d9d9d9',
                      borderRadius: 6,
                      overflow: 'hidden',
                    }}
                  >
                    <ReactQuill
                      value={description}
                      onChange={setDescription}
                      theme="snow"
                      style={{
                        height: 180,
                        marginBottom: 0,
                      }}
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      type="primary"
                      size="small"
                      loading={loading}
                      onClick={async () => {
                        autoSaveSubtask('description', description);

                        setIsEditingDesc(false);
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      size="small"
                      type="text"
                      onClick={() => setIsEditingDesc(false)}
                    >
                      cancel
                    </Button>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    padding: '12px',
                    borderRadius: 6,
                    minHeight: 80,
                    cursor: 'pointer',
                  }}
                  onClick={() => setIsEditingDesc(true)}
                  dangerouslySetInnerHTML={{
                    __html:
                      subtaskDetails?.description ||
                      '<p style="color:gray;">Add a description...</p>',
                  }}
                />
              )}
            </Panel>

             {openLinkWorkItem && (
              <div style={{ marginTop: '16px' }}>
                
                <LinkWorkItemInput
                  onCancel={() => setOpenLinkWorkItem(false)}
                  current_item_type={'subtask'}
                  current_item_id={subtaskDetails?.subtask_id}
                  onSuccess={triggerRefresh}
                />
              </div>
            )}
            {showWebLink && (
              <WebLink
                onClose={() => setShowWebLink(false)}
                onSave={handleSaveLink}
                work_id={subtaskDetails?.subtask_id}
                work_type={'subtask'}
              />
            )}
            <WebLinkList
              work_id={subtaskDetails?.subtask_id}
              work_type={'subtask'}
              refreshFlag={refreshLinks}
            />

            {workItems?.length > 0 && (
              <Tab
                fontSize="12px"
                px="8px"
                py="3px"
                _selected={{
                  border: '1px solid #3182CE',
                  color: '#3182CE',
                  bg: 'white',
                  borderRadius: '4px',
                }}
              >
                Linked Items
              </Tab>
            )}

            {workItems?.length > 0 && (
              <ListLinkedWorkItems
                item_id={subtaskDetails?.subtask_id}
                item_type={'subtask'}
                refreshFlag={refreshLinkedItems}
              />
            )}

           

            {/* Detail */}

            {/* {!isExpanded && ( */}
            <Panel
              header={
                <span style={{ fontSize: 18, fontWeight: 600 }}>Details</span>
              }
              key="details"
              style={{ background: 'transparent' }}
            >
              <DetailsPage
                assignee={assignee}
                setAssignee={setAssignee}
                assigneeOptions={assigneeOptions || []}
                labelOptions={labelOptions || []}
                labels={labels}
                setLabels={setLabels}
                epicOptions={epicOptions || []}
                epic={epic}
                setEpic={setEpic}
                dueDate={dueDate}
                setDueDate={setDueDate}
                startDate={startDate}
                setStartDate={setStartDate}
                story_points={story_points}
                setStoryPoints={setStoryPoints}
                autoSaveSubtask={autoSaveSubtask}
                subtaskLabelUpdate={subtaskLabelUpdate}
                subtaskDetails={subtaskDetails}
              />
            </Panel>
            {/* )} */}

            {/* Activity */}
            <Panel
              header={
                <span style={{ fontSize: 18, fontWeight: 600 }}>Activity</span>
              }
              key="activity"
              style={{ background: 'transparent' }}
            >
              <div style={{ marginBottom: 24 }}>
                <SubtaskmodalActivity
                  subtaskDetails={subtaskDetails}
                  subtaskdata={subtaskDetails}
                  selectedSubtask={subtaskDetails?.subtask_id}
                  projectId={projectId}
                  refreshKey={refreshKey}
                />
              </div>
            </Panel>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default SubtaskDetailModal;
